document.addEventListener('on:variant:change', (event) => {
  const { variant, product } = event.detail;
  const detailsEl = document.querySelector('#variant-details');
  console.log('Variant change event triggered:', variant);
  
  if (!detailsEl) {
    console.log('Variant details element not found');
    return;
  }
  
  // Get the variant details from the formatted data
  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) {
    console.log('Variant picker not found');
    return;
  }
  
  const data = variantPicker.getProductData();
  const key = String(variant.id);
  const variantData = data.formatted[key];
  console.log('Variant data:', variantData);
  
  const newDetails = variantData && variantData.variantDetails ? variantData.variantDetails : '';
  console.log('New details to display:', newDetails);
  
  detailsEl.innerHTML = newDetails;
});
